import 'COMMON';
import 'Lib/js-anchor-link/js-anchor-link';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import 'Bem/site/about-company/about-company';
import 'Bem/site/rdc-map/rdc-map';
import 'Bem/site/brands/brands';
import 'Bem/site/spoiler/spoiler';
import 'Bem/journal/gallery/gallery';
import 'Bem/site/list-author-blocks/list-author-blocks';
import 'Bem/site/radio/radio';
// import 'Bem/site/pay-and-delivery/pay-and-delivery'; Скрываем до появления новой ЧГ корзины
import 'Bem/site/publications/publications';
import 'Bem/site/books-slider/books-slider';
import 'Bem/site/book/book';
import 'Bem/site/shop-matrix/shop-matrix';
import 'Bem/site/menu-left/menu-left';
import { oLike } from 'Lib/like/like';

oLike.init('.js-book-like');
svgSpriteLoader('/site/about-company/svg/sprite.svg?v=20190212');